import React from 'react';

import SignUpComponent from '../../components/SignUpComponents/SignUpComponent';


function Signup() {
  return (
    <div className="w-screen h-screen flex items-center justify-center">
       <SignUpComponent/>
    </div>
  )
}

export default Signup;